module.exports = __webpack_public_path__ + "static/gray-halftone-dots-18582b0027c49f05e0000715e01db33a.svg";